import { Typography, Box } from "@mui/material";
import Tile from "components/Tile.jsx";

export default function CustomerDetailsCard({ customer }) {
  if (!customer) {
    return null;
  }

  return (
    <Tile sx={{ mb: 3 }}>
      <Typography variant="h5" gutterBottom>
        Kundeninformationen
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
        <Typography>
          <strong>Kundenname:</strong> {customer.name1}
        </Typography>
        {customer.id_ov && (
          <Typography>
            <strong>OV-ID:</strong> {customer.id_ov}
          </Typography>
        )}
      </Box>
    </Tile>
  );
}
